














import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IItem, instanceOfIItem,
  instanceOfITextCopyable,
  instanceOfIDrawableItem,
} from "../../../../domain/document/items";
import {
  IObject,
  instanceOfIFreeInputableObject,
  instanceOfIItemPastableObject,
  instanceOfIItemCopyableObject,
} from "../objects";
import { ObjectClipboardMixin } from "../objects/mixins";
import DateInputMethodSelector from "../inputMethodEditors/DateInputMethodSelector.vue";
import { CommonComponentsAccessibleMixin } from "../mixins";
import ObjectMenuButton from "./ObjectMenuButton.vue";

@Component({
  components: {
    DateInputMethodSelector,
    ObjectMenuButton,
  }
})
export default class ClipboardMenu extends Mixins(CommonComponentsAccessibleMixin, ObjectClipboardMixin) {
  @Prop()
  source: IObject;

  data(): any {
    return {
      clippingValue: null,
    };
  }
  clippingValue: string | IItem;

  mounted(): void {
    this.commonComponents.adapters.clipboard.paste()
      .then(v => this.clippingValue = v);
  }

  get isVisible(): boolean {
    return instanceOfIItemCopyableObject(this.source)
        || instanceOfIItemPastableObject(this.source)
        || instanceOfIFreeInputableObject(this.source);
  }

  get isObjectCopyable(): boolean {
    return instanceOfIDrawableItem(this.source.editingSource) && this.getObjectCopyable(this.source.editingSource, true);
  }

  get copyDescription(): string {
    if (!this.isTextSelected && this.isObjectCopyable) {
      return "オブジェクトのコピーを行います。";
    }
    return instanceOfIItemCopyableObject(this.source)
      ? ("値をコピーします。" + (instanceOfIFreeInputableObject(this.source) ? "フリー入力中は選択されてるテキストをコピーします。" : ""))
      : "フリー入力中に選択されてるテキストをコピーします。";
  }

  get isCopyable(): boolean {
    return this.isTextSelected
        || this.isItemCopyable
        || this.isObjectCopyable;
  }

  /**
   * RichTextBoxObjectに対してgetSelectedText()を呼ぶと何らかの更新監視をキックしてしまう模様で、
   * 複数のgetterから呼ぶ実装のときにgetterが交互に動作して無限ループするので要注意
   * source.shouldInputFreeSelfOrAllもチェックすると入力不可のオブジェクトからコピーできなくなってしまうのでチェックしないようにしている
   */
  get isTextSelected(): boolean {
    return instanceOfIFreeInputableObject(this.source)
        && !!this.source.getSelectedText();
  }

  get isFreeInputable(): boolean {
    return instanceOfIFreeInputableObject(this.source)
        && this.source.shouldInputFreeSelfOrAll;
  }

  get isItemCopyable(): boolean {
    return (!instanceOfIFreeInputableObject(this.source) || !this.source.shouldInputFreeSelfOrAll)
        && instanceOfIItemCopyableObject(this.source)
        && !this.source.isSourceEmpty;
  }

  get isPastable(): boolean {
    return this.isTextPastable
        || this.isItemPastable
        || this.isItemPastableAsText;
  }

  get isTextPastable(): boolean {
    return this.clippingValue
        && (typeof(this.clippingValue) === "string")
        && instanceOfIFreeInputableObject(this.source)
        && this.source.shouldInputFreeSelfOrAll;
  }

  get isItemPastable(): boolean {
    return instanceOfIItem(this.clippingValue)
        && instanceOfIItemPastableObject(this.source)
        && this.source.isItemPastable(this.clippingValue);
  }

  get isItemPastableAsText(): boolean {
    return instanceOfIItem(this.clippingValue)
        && instanceOfITextCopyable(this.clippingValue)
        && this.clippingValue.textToCopy
        && instanceOfIFreeInputableObject(this.source)
        && this.source.shouldInputFreeSelfOrAll;
  }

  get isCuttable(): boolean {
    return this.isSelectedTextCuttable;
  }

  get isSelectedTextCuttable(): boolean {
    return this.isFreeInputable && this.isTextSelected;
  }

  copy(): void {
    if (this.isTextSelected) {
      this.commonComponents.adapters.clipboard.copy();
    } else if (this.isItemCopyable) {
      this.commonComponents.adapters.clipboard.copy(this.source.editingSource.clone());
    } else if (this.isObjectCopyable && instanceOfIDrawableItem(this.source.editingSource)) {
      this.copyToObjectClipboard(this.source.editingSource);
    }
  }

  paste(): void {
    if (this.isTextPastable && instanceOfIFreeInputableObject(this.source)) {
      this.source.pasteText(this.clippingValue as string);
    } else if (this.isItemPastable && instanceOfIItemPastableObject(this.source)) {
      this.source.pasteItem(this.clippingValue as IItem);
    } else if (this.isItemPastableAsText && instanceOfIFreeInputableObject(this.source) && instanceOfITextCopyable(this.clippingValue)) {
      this.source.pasteText(this.clippingValue.textToCopy);
    }
  }

  cut(): void {
    if (this.isSelectedTextCuttable && instanceOfIFreeInputableObject(this.source)) {
      this.commonComponents.adapters.clipboard.copy();
      this.source.removeSelectedText();
    }
  }
}
